var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyversionhistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.617 14.2354C196.247 14.2354 200 17.8908 200 22.4C200 26.9093 196.247 30.5647 191.617 30.5647H143.713C148.342 30.5647 152.096 34.2202 152.096 38.7294C152.096 43.2386 148.342 46.8941 143.713 46.8941H170.06C174.69 46.8941 178.443 50.5495 178.443 55.0587C178.443 59.568 174.69 63.2234 170.06 63.2234H157.876C152.038 63.2234 147.305 66.8789 147.305 71.3881C147.305 74.3943 149.701 77.1158 154.491 79.5528C159.121 79.5528 162.874 83.2082 162.874 87.7175C162.874 92.2267 159.121 95.8821 154.491 95.8821H55.0898C50.4599 95.8821 46.7066 92.2267 46.7066 87.7175C46.7066 83.2082 50.4599 79.5528 55.0898 79.5528H8.38323C3.7533 79.5528 0 75.8973 0 71.3881C0 66.8789 3.7533 63.2234 8.38323 63.2234H56.2874C60.9174 63.2234 64.6707 59.568 64.6707 55.0587C64.6707 50.5495 60.9174 46.8941 56.2874 46.8941H26.3473C21.7174 46.8941 17.9641 43.2386 17.9641 38.7294C17.9641 34.2202 21.7174 30.5647 26.3473 30.5647H74.2515C69.6216 30.5647 65.8683 26.9093 65.8683 22.4C65.8683 17.8908 69.6216 14.2354 74.2515 14.2354H191.617ZM191.617 46.8941C196.247 46.8941 200 50.5495 200 55.0587C200 59.568 196.247 63.2234 191.617 63.2234C186.987 63.2234 183.234 59.568 183.234 55.0587C183.234 50.5495 186.987 46.8941 191.617 46.8941Z",
    fill: "#D6DCE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4.18281H115.86C116.484 4.18281 116.98 4.46877 117.574 5.02608C117.873 5.30618 118.186 5.64426 118.549 6.03643L118.55 6.03703C118.906 6.42199 119.306 6.8541 119.773 7.3153C121.755 9.99036 125.099 13.3958 128.765 16.9283C130.537 18.6362 132.376 20.3663 134.18 22.0627C136.103 23.8707 137.984 25.6404 139.7 27.3039V97.5523C139.7 102.83 135.363 107.112 130 107.112H70C64.6367 107.112 60.3 102.83 60.3 97.5523V13.7428C60.3 8.4648 64.6367 4.18281 70 4.18281Z",
    fill: "#FDFEFF",
    stroke: "#F6F6F6",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.333 4.41221L117.333 22.6449C117.323 25.26 119.657 27.3528 122.342 27.3658L140 27.1768",
    fill: "#E6EEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 68.4894H120.666H70.666Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 68.4894H120.666",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 76.2296H120.666H70.666Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 76.2296H120.666",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 86.7064H107.999H70.666Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 86.7064H107.999",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 94.471H93.3327H70.666Z",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 94.471H93.3327",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.666 94.471H107.999H98.666Z",
    fill: "#D5DDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.666 94.471H107.999",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 60.8236H120.666H70.666Z",
    fill: "#D5DDEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 60.8236H120.666",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.666 53.4533H94.1125H70.666Z",
    fill: "#D5DDEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.666 53.4533H94.1125",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1597 28.3797C98.1597 30.2993 97.5732 32.1759 96.4744 33.772C95.3756 35.3681 93.8139 36.6122 91.9867 37.3468C90.1594 38.0814 88.1488 38.2736 86.2091 37.8991C84.2693 37.5246 82.4875 36.6002 81.089 35.2428C79.6905 33.8854 78.7381 32.156 78.3523 30.2732C77.9665 28.3905 78.1645 26.4389 78.9213 24.6654C79.6782 22.8919 80.9599 21.3761 82.6043 20.3096C84.2488 19.2431 86.1821 18.6738 88.1599 18.6738C90.8111 18.6767 93.3529 19.7002 95.2276 21.5198C97.1022 23.3394 98.1567 25.8064 98.1597 28.3797ZM92.1098 29.6393L89.271 27.8027V22.9876C89.271 22.7015 89.1539 22.4272 88.9456 22.225C88.7372 22.0227 88.4546 21.9091 88.1599 21.9091C87.8652 21.9091 87.5826 22.0227 87.3743 22.225C87.1659 22.4272 87.0488 22.7015 87.0488 22.9876V28.3797C87.0488 28.5572 87.0939 28.732 87.1802 28.8885C87.2664 29.045 87.3911 29.1784 87.5433 29.277L90.8765 31.4338C91.1217 31.5926 91.4218 31.6503 91.7108 31.5942C91.9998 31.5382 92.254 31.3731 92.4176 31.1351C92.5811 30.8971 92.6406 30.6059 92.5829 30.3253C92.5252 30.0448 92.355 29.7981 92.1098 29.6393Z",
    fill: "#B8C1D2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 29.4585L72.8117 32.2324L75.625 29.4585",
    stroke: "#D5DDEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8132 32.4035L72.8132 28.7638C72.8132 20.7225 79.5281 14.2066 87.8129 14.2066C96.0977 14.2066 102.813 20.7241 102.813 28.7654C102.813 36.8067 96.0977 43.3242 87.8129 43.3242C83.0796 43.3242 78.8631 41.1905 76.1148 37.8647",
    stroke: "#D5DDEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyversionhistory);
export default __webpack_public_path__ + "static/media/emptyversionhistory.0d39a9de260dea6ace1918332ff6cfde.svg";
export { ForwardRef as ReactComponent };